<template>
  <section class="section--comp">
    <div class="container items-center">
      <h3 class="section--h3">Marketplace</h3>
      <p class="section--p">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce tincidunt
        turpis a augue convallis.
      </p>
      <div class="items-center" style="margin-bottom: 5rem">
        <vs-input
          size="large"
          icon-pack="feather"
          icon="icon-search"
          placeholder="Search"
          v-model="value1"
          class="items-left search-apps is-label-placeholder w-1/2"
        />
      </div>
      <div class="items-left">
        <h3 class="section--h3 mb-base p-3">All Apps</h3>
        <div class="p-3 mb-5">
          <vx-card class="api-key-card flex">
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2"
              >
                <div class="api-key-text">Your API Key</div>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="5"
              >
                <vs-input class="api-key-gen w-full" v-model="api_key_value" />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="5"
              >
                <vs-button
                  class="mr-base"
                  type="border"
                  color="#848199"
                  icon-pack="feather"
                  icon="icon-copy"
                  >Copy Key</vs-button
                >
                <vs-button
                  type="border"
                  color="#848199"
                  icon-pack="feather"
                  icon="icon-refresh-cw"
                  >Regenerate Key</vs-button
                >
              </vs-col>
            </vs-row>
          </vx-card>
        </div>
        <vs-row class="mb-base" vs-type="flex">
          <vs-col
            v-for="(cd, index) in cardData"
            :key="index"
            class="sm:w-full lg:w-1/3 p-3"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <vx-card class="items-left">
              <div>
                <span
                  class="
                    p-3
                    inline-flex
                    feather-icon
                    select-none
                    relative
                    text-primary
                    mr-5
                  "
                  style="border-radius: 12px; float: left"
                  :style="cd.bg"
                >
                  <img
                    :src="cd.img"
                    :alt="cd.title"
                    width="40px"
                    height="40px"
                  />
                </span>
                <div class="p-3">
                  <h4 class="card-title">{{ cd.title }}</h4>
                  <span class="card-subtitle">by GetBoarded</span>
                </div>
              </div>
              <br />
              <div class="items-left mb-0">
                <p class="card-description">
                  {{ cd.description }}
                </p>
              </div>
            </vx-card>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Marketplace",
  data() {
    return {
      cardData: [
        {
          img: require("../../../../../src/assets/images/icons/app-marketplace/editor.svg"),
          title: "Editor",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
        },
        {
          img: require("../../../../../src/assets/images/icons/app-marketplace/resume-parser.svg"),
          title: "Resume Parser",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
        },
        {
          img: require("../../../../../src/assets/images/icons/app-marketplace/ats.svg"),
          title: "ATS",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
        },
        {
          img: require("../../../../../src/assets/images/icons/app-marketplace/alex.svg"),
          title: "ALEX",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
        },
        {
          img: require("../../../../../src/assets/images/icons/app-marketplace/dex.svg"),
          title: "DEX",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
        },
        {
          img: require("../../../../../src/assets/images/icons/app-marketplace/opex.svg"),
          title: "OPEX",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
        },
        {
          img: require("../../../../../src/assets/images/icons/app-marketplace/digital-footprint.svg"),
          title: "Digital Footprint",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
        },
        {
          img: require("../../../../../src/assets/images/icons/app-marketplace/api-explorer.svg"),
          title: "API Explorer",
          bg: "background: linear-gradient(137.44deg, #FBA727 0.01%, #FFD088 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
        },
        {
          img: require("../../../../../src/assets/images/icons/app-marketplace/studio.svg"),
          title: "Studio",
          bg: "background: linear-gradient(137.44deg, #645ADE 0.01%, #C799F4 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
        },
        {
          img: require("../../../../../src/assets/images/icons/app-marketplace/mycoach.svg"),
          title: "My Coach",
          bg: "background: linear-gradient(137.44deg, #84B334 0.01%, #A7CA6B 103.87%);",
          description:
            "Nunc consectetur odio in tellus aliquet imperdiet. Interdum et malesuada.",
        },
      ],
      value1: null,
      api_key_value: null,
    };
  },
  created() {
    this.$store.commit("SET_PAGE_TYPE", "marketplace");
    this.$store.commit(
      "SET_PAGE_FOOTER_BACKGROUND_COLOR",
      "linear-gradient(104.96deg, #F29300 0.72%, #FFC000 94.5%)"
    );
    // console.log(
    //   "Background Color",
    //   this.$store.state.pageFooterBackgroundColor
    // );
  },
};
</script>

<style scoped>
.section--comp {
  padding: 10rem;
}
.search-apps >>> input {
  background: #f5f5f5 !important;
  border-radius: 100px !important;
}
button {
  border-radius: 5px;
}
.api-key-gen >>> input {
  background: #f5f5f5 !important;
}
.api-key-card {
  border: 1px solid #eaf1fb;
  box-shadow: none;
}
.api-key-text {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #000000;
}
</style>